// src/store/deviceStore.ts
import { defineStore } from "pinia";
import { createDeviceDetector } from "@/utils/device";

export const useDeviceStore = defineStore("device", () => {
    const detector = createDeviceDetector();

    detector.initDeviceType();

    window.addEventListener("resize", detector.updateScreenSize);

    const cleanup = () => {
        window.removeEventListener("resize", detector.updateScreenSize);
    };

    return {
        screenWidth: detector.screenWidth,
        screenHeight: detector.screenHeight,
        isMobile: detector.isMobile,
        cleanup
    };
});